jQuery(document).ready(function ($) {

  const hamburgerIcon = $(".js-hamburger-icon");
  const closeIcon = $(".js-close-sidebar-menu");
  const headerMenu = $(".byrna-mega-menu-sidebar");
  const listHeaders = $(".js-list-header");
  const body = $("body");
  const bodyElement = $("body");
  const BREAKPOINT = 992;
  const menuItems = $(".byrna-mega-menu__nav-list > li").has(".js-list-body");
  let ga4HoverTimer;
  let hoverCloseTimer;
  let viewedLi = null;

  /* Elements hidden while the mobile drawer is open. Theme-rendered elements can opt in with
     the data-hide-on-mobile-menu attribute (no JS change needed); third-party widgets we don't
     render (Zendesk #launcher, accessibility app, OneTrust) are listed here by selector. */
  const HIDE_ON_MOBILE_MENU = "#launcher, #accessiblyAppWidgetButton, #onetrust-consent-sdk, [data-hide-on-mobile-menu]";

  /* Fire feature_view once per open session — guards against hover + keyboard double-fire */
  function firePanelView($li) {
    const el = $li.get(0);
    if (!el || viewedLi === el) return;
    viewedLi = el;
    if (window.ByrnaGA4) {
      ByrnaGA4.featureView('dynamic_mega_menu', '1224', {
        element: $li.data('mega-name') || ''
      });
    }
  }

  /* Reset nested sub-lists (e.g. "Shop Ammo by Launcher") inside a collapsing column back to
     their original state, so reopening the column does not remember a previously-open sub-list.
     Clearing the inline display (rather than forcing display:none) lets CSS reassert the true
     default — collapsed normally, but open for [data-always-open="true"] columns. */
  function resetNestedSubmenus($scope) {
    $scope.find('.ammo-main-submenu').removeClass('is-open')
      .children('.ammo-submenu').stop(true, true).css('display', '');
  }

  /* Desktop keyboard disclosure: explicit open/close state on the <li> */
  function openPanel($li) {
    if ($li.hasClass('is-open')) return;
    $li.addClass('is-open');
    $li.children('.js-list-header').find('.byrna-mega-menu__navlink').attr('aria-expanded', 'true');
    body.addClass('is-megamenu-open');
  }

  function closePanel($li) {
    $li.removeClass('is-open');
    $li.children('.js-list-header').find('.byrna-mega-menu__navlink').attr('aria-expanded', 'false');
    if ($('.byrna-mega-menu__nav-list > li.is-open').length === 0) {
      body.removeClass('is-megamenu-open');
    }
  }

  /* =========================
   AMMO SUBMENU (DESKTOP + MOBILE)
  ========================= */

  const ammoItem = $(".ammo-main-submenu");

  /* Desktop hover — skip always-open columns */
  if (window.innerWidth >= BREAKPOINT) {
    ammoItem.each(function () {
      const $item = $(this);
      if ($item.closest("[data-always-open='true']").length > 0) return;

      $item.on("mouseenter", function () {
        $item.children(".ammo-submenu").stop(true, true).fadeIn(200);
      });
      $item.on("mouseleave", function () {
        $item.children(".ammo-submenu").stop(true, true).fadeOut(200);
      });
    });
  }

  /* Mobile click toggle (always click on mobile, skip always-open columns) */
  $(document).on("click", ".ammo-main-submenu > a, .ammo-main-submenu > span", function (e) {
    if (window.innerWidth < BREAKPOINT) {
      const parent = $(this).closest(".ammo-main-submenu");
      e.preventDefault();
      parent.children(".ammo-submenu").stop(true, true).slideToggle(250);
      parent.toggleClass("is-open");
    }
  });

  /* Mobile accordion (columns + top-level nav). Bound ONCE here (not in initMobileMenu) so it
     can't stack: initMobileMenu re-runs on every resize, and a delegated handler re-bound there
     with no .off() would multiply, firing the toggle an even number of times (open→close) and
     mixing up state. The breakpoint guard keeps it inert on desktop (native link nav / hover). */
  $(document).off("click.accordion").on("click.accordion", ".js-list-header", function (e) {
    if (window.innerWidth >= BREAKPOINT) return;
    e.stopPropagation();
    e.preventDefault();

    const trigger = $(this);
    const parentItem = trigger.parent(); // div or li
    const body = trigger.next('.js-list-body');

    // No panel to expand — navigate only if this row is a real link (guards undefined href).
    if (!body.length) {
      const href = trigger.find('a').attr('href');
      if (href) { window.location = href; }
      return;
    }

    const navlink = trigger.find('.byrna-mega-menu__navlink');
    const isOpen = trigger.hasClass('is-active-accordion');

    if (isOpen) {
      trigger.removeClass('is-active-accordion');
      navlink.attr('aria-expanded', 'false');
      body.removeClass('is-active-accordion').slideUp(300);
      resetNestedSubmenus(body);
    } else {
      if (trigger.hasClass('byrna-mega-menu-sidebar__list-header') && parentItem.data('mega-name') && window.ByrnaGA4) {
        ByrnaGA4.featureView('dynamic_mega_menu', '1224', {
          element: parentItem.data('mega-name')
        });
      }

      // ✅ close ONLY same-level siblings
      parentItem.siblings().each(function () {
        const siblingHeader = $(this).children('.js-list-header');
        const siblingBody = $(this).children('.js-list-body');

        siblingHeader.removeClass('is-active-accordion');
        siblingHeader.find('.byrna-mega-menu__navlink').attr('aria-expanded', 'false');
        siblingBody.removeClass('is-active-accordion').slideUp(300);
        resetNestedSubmenus(siblingBody);
      });

      // ✅ open current
      trigger.addClass('is-active-accordion');
      navlink.attr('aria-expanded', 'true');
      body.addClass('is-active-accordion').slideDown(300);
    }
  });

  /* =========================
     COMMON FUNCTIONS
  ========================= */

  function openMenu() {
    headerMenu.addClass("is-active-menu");
    bodyElement.addClass("is-active-menu is-overlay-enabled");

    // ✅ toggle icons
    hamburgerIcon.hide();
    closeIcon.show();

    // ✅ hide floating widgets
    $(HIDE_ON_MOBILE_MENU).css("display", "none");

    // ✅ move focus into the drawer for keyboard/screen-reader users
    const firstControl = headerMenu.find(".byrna-mega-menu__navlink, .js-list-header a").filter(":visible").first();
    if (firstControl.length) firstControl.get(0).focus({ preventScroll: true });
  }

  function closeMenu() {
    headerMenu.removeClass("is-active-menu");
    bodyElement.removeClass("is-active-menu is-overlay-enabled");

    // ✅ toggle icons
    hamburgerIcon.show();
    closeIcon.hide();

    // ✅ restore floating widgets
    $(HIDE_ON_MOBILE_MENU).css("display", "");

    // ✅ return focus to the trigger
    if (hamburgerIcon.length) hamburgerIcon.get(0).focus({ preventScroll: true });
  }

  /* =========================
     MOBILE MENU
  ========================= */

  function initMobileMenu() {

    hamburgerIcon.off("click").on("click", function (e) {
      e.preventDefault();
      checkHeaderOffset();
      if (!headerMenu.hasClass("is-active-menu")) {
        openMenu();
      }
    });

    closeIcon.off("click").on("click", function (e) {
      e.preventDefault();
      closeMenu();
    });

    $(document).off("click.mobile").on("click.mobile", function (e) {
      if (
        !$(e.target).closest(headerMenu).length &&
        !$(e.target).closest(hamburgerIcon).length &&
        !$(e.target).closest(".announcement-bar").length &&
        headerMenu.hasClass("is-active-menu")
      ) {
        closeMenu();
      }
    });

    /* Escape closes the mobile drawer and returns focus to the hamburger */
    $(document).off("keydown.mobile").on("keydown.mobile", function (e) {
      if ((e.key === "Escape" || e.key === "Esc") && headerMenu.hasClass("is-active-menu")) {
        closeMenu();
      }
    });

  }

  function getVisibleHeight(el) {
    if (!el) return 0;

    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, windowHeight);

    const visibleHeight = visibleBottom - visibleTop;

    return Math.max(0, visibleHeight);
  }

  function checkHeaderOffset() {
    const $header = $(".byrna-mega-menu__main");
    const $announcementBar = $(".announcement-bar");
    const $topGeoBar = $(".top-geo-bar"); // 👈 your geo bar class

    let totalOffset = 0;
    let announcementBarOffset = 0;
    let topGeoBarOffset = 0;

    // Geo bar height
    if ($topGeoBar.length && $topGeoBar.is(":visible")) {
      topGeoBarOffset = getVisibleHeight($topGeoBar[0]);
      totalOffset += topGeoBarOffset;
    }

    // Header height
    if ($header.length && $header.is(":visible")) {
      totalOffset += $header.outerHeight();
    }

    // Announcement bar height
    if ($announcementBar.length && $announcementBar.is(":visible")) {
      announcementBarOffset = getVisibleHeight($announcementBar[0]);
      totalOffset += announcementBarOffset;
    }

    // Set CSS variables
    document.documentElement.style.setProperty("--header-offset", `${totalOffset}px`);
    document.documentElement.style.setProperty("--announcement-bar-offset", `${announcementBarOffset}px`);
    document.documentElement.style.setProperty("--top-geo-bar-offset", `${topGeoBarOffset}px`);
  }

  /* =========================
     DESKTOP MENU
  ========================= */

  function initDesktopMenu() {

    menuItems.off("mouseenter mouseleave keydown focusout");

    /* Hover open: drive the panel via the is-open class (not bare :hover) so it stays
       revealed while the cursor crosses the dead band between the trigger and the panel,
       which is anchored flush to the header bottom and therefore sits below the <li>. */
    menuItems.on("mouseenter", function () {
      const $li = $(this);
      clearTimeout(hoverCloseTimer);

      // Single-open: collapse any other open panel immediately
      menuItems.not($li).each(function () { closePanel($(this)); });

      openPanel($li);

      clearTimeout(ga4HoverTimer);
      ga4HoverTimer = setTimeout(function () {
        firePanelView($li);
      }, 250);
    });

    menuItems.on("mouseleave", function () {
      const $li = $(this);
      clearTimeout(ga4HoverTimer);

      // Grace period: moving from the trigger down to the panel briefly leaves the <li>
      // (the cursor passes over the header gap). Delay the close so re-entering the panel
      // cancels it; a genuine mouse-out closes after the grace window. viewedLi is reset only
      // here (not on every mouseleave) so crossing the gap doesn't re-arm the GA4 view fire.
      clearTimeout(hoverCloseTimer);
      hoverCloseTimer = setTimeout(function () {
        closePanel($li);
        viewedLi = null;
      }, 200);
    });

    /* Keyboard disclosure on the trigger link: Enter navigates (native); Space/ArrowDown opens; Escape closes */
    menuItems.children(".js-list-header").find(".byrna-mega-menu__navlink").off("keydown.mega").on("keydown.mega", function (e) {
      const $li = $(this).closest("li");
      const key = e.key;

      if (key === " " || key === "Spacebar" || key === "ArrowDown") {
        e.preventDefault();
        openPanel($li);
        firePanelView($li);
        const first = $li.find(".js-list-body a, .js-list-body button").filter(":visible").first();
        if (first.length) first.get(0).focus({ preventScroll: true });
      } else if (key === "Escape" || key === "Esc") {
        closePanel($li);
      }
    });

    /* Escape from inside an open panel closes it and returns focus to the trigger */
    menuItems.on("keydown", ".js-list-body", function (e) {
      if (e.key === "Escape" || e.key === "Esc") {
        const $li = $(this).closest("li");
        closePanel($li);
        const trigger = $li.children(".js-list-header").find(".byrna-mega-menu__navlink").get(0);
        if (trigger) trigger.focus({ preventScroll: true });
      }
    });

    /* Close when keyboard focus leaves the item entirely (e.g. Tab out) */
    menuItems.on("focusout", function () {
      const $li = $(this);
      setTimeout(function () {
        if (!$.contains($li.get(0), document.activeElement)) {
          closePanel($li);
        }
      }, 0);
    });
  }

  /* =========================
     INIT BASED ON SCREEN
  ========================= */

  function initMenuByScreen() {
    if ($(window).width() >= BREAKPOINT) {
      initDesktopMenu();
    } else {
      initMobileMenu();
    }
  }

  initMenuByScreen();

  /* =========================
     RE-INIT ON RESIZE
  ========================= */

  $(window).on("resize", function () {
    initMenuByScreen();
    checkHeaderOffset();
  });

  window.addEventListener("load", function () {
    // Run header offset
    checkHeaderOffset();
  });

  /* =========================
     GA4 MEGA MENU TRACKING
  ========================= */

  $(document).on('click', '.byrna-mega-menu__megamenu [data-mega-link], .byrna-mega-menu-sidebar [data-mega-link]', function () {
    if (window.ByrnaGA4) {
      ByrnaGA4.featureClick('dynamic_mega_menu', '1224', {
        element: $(this).data('mega-link') || '',
        destination_url: ByrnaGA4.trunc($(this).data('mega-link-url') || '', 100)
      });
    }
  });

});